import { useEffect, useRef, useState } from 'react';
import { checkPasswordStrength } from '../utils';

/**
 * Used in:
 *   - RegisterPage (src/features/auth/pages/RegisterPage.js)
 */
export const usePasswordStrength = (password) => {
  const [strength, setStrength] = useState({
    hasUppercase: false,
    hasNumber: false,
    hasSpecial: false,
    hasMinLength: false,
    isValid: false
  });
  const [showTooltip, setShowTooltip] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      if (password) {
        const next = checkPasswordStrength(password);
        // Skip state updates if nothing changed to reduce renders
        if (
          next.hasUppercase !== strength.hasUppercase ||
          next.hasNumber !== strength.hasNumber ||
          next.hasSpecial !== strength.hasSpecial ||
          next.hasMinLength !== strength.hasMinLength ||
          next.isValid !== strength.isValid
        ) {
          setStrength(next);
        }
        setShowTooltip(true);
      } else {
        setShowTooltip(false);
      }
    }, 120);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [password]);

  const handlePasswordFocus = () => {
    if (password) setShowTooltip(true);
  };

  const handlePasswordBlur = () => {
    // Keep tooltip visible until requirements are met; hide only when valid or empty
    setTimeout(() => {
      setShowTooltip(Boolean(password) && !strength.isValid ? true : false);
    }, 200);
  };

  return { strength, showTooltip, handlePasswordFocus, handlePasswordBlur };
};


